<div class="chat-header">
    <img src="/assets/images/apple-touch-icon.png" class="chat-logo" alt="Horizinns alternate logo"/>
    <div class="chat-title">
        Reservation Info
    </div>
</div>
<div class="chat-container">
    <div class="message-list" #scrollFrame>
        @for (msg of messages(); track $index) {
        <div class="message-bubble" [@bubbleIn] [ngClass]="msg.sender">
            {{ msg.text }}
        </div>
        }

        @if (isTyping()) {
        <div class="message-bubble system">
            <div class="typing-indicator">
                <span></span><span></span><span></span>
            </div>
        </div>
        }
    </div>

    <div class="input-area">
        @if (currentStep === 0 && !isTyping()) {
        <div class="chat-input-pill" (click)="picker.open()">
            <span class="pill-text">
                @if (bookingData.startDate && bookingData.endDate) {
                {{ bookingData.startDate | date:'shortDate' }} - {{ bookingData.endDate | date:'shortDate' }}
                } @else {
                Select your dates...
                }
            </span>
            <mat-icon>calendar_today</mat-icon>

            <mat-date-range-input [rangePicker]="picker" class="hidden-input">
                <input matStartDate placeholder="Start date">
                <input matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
        </div>
        }

        @if (currentStep === 1 && !isTyping()) {
        <div class="chat-input-pill transparent">
            <mat-chip-listbox aria-label="Contact method selection">
                <mat-chip-option (selectionChange)="onMethodSelected('Call')" color="primary">
                    Call
                </mat-chip-option>
                <mat-chip-option (selectionChange)="onMethodSelected('Text')" color="primary">
                    Text
                </mat-chip-option>
                <mat-chip-option (selectionChange)="onMethodSelected('Email')" color="primary">
                    Email
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
        }

        @if (currentStep == 2 && !isTyping()) {
        @if (bookingData.contactMethod === 'email') {
        <div class="chat-input-pill">
            <input type="email" #emailInput placeholder="Enter your email..."
                (keyup.enter)="addReply(emailInput.value, 'Finally, any message for the owner?', 'email')">
            <button mat-icon-button
                (click)="addReply(emailInput.value, 'Finally, any message for the owner?', 'email')">
                <mat-icon>send</mat-icon>
            </button>
        </div>
        }
        @if (bookingData.contactMethod === 'text' || bookingData.contactMethod === 'call') {
        <div class="chat-input-pill">
            <input type="tel" #phoneInput placeholder="Enter your number..."
                (input)="phoneInput.value = formatPhoneNumber(phoneInput.value)"
                (keyup.enter)="addReply(phoneInput.value, 'Finally, any message for the owner?', 'phone')">
            <button mat-icon-button
                (click)="addReply(phoneInput.value, 'Finally, any message for the owner?', 'phone')">
                <mat-icon>send</mat-icon>
            </button>
        </div>
        }
        }

        @if (currentStep === 3 && !isTyping()) {
            <div class="chat-input-pill multiline">
                <textarea #msgInput placeholder="Tell them about your trip..." rows="1"></textarea>
                <button mat-icon-button (click)="addReply(msgInput.value, undefined, 'message')">
                    <mat-icon>send</mat-icon>
                </button>
            </div>
        }

        @if (currentStep === 4 && !isTyping()) {
            <div class="input-area">
            <div class="success-footer" [@bubbleIn]>
            <mat-icon>check_circle</mat-icon>
            <div class="success-text">
                <p>Inquiry Sent to Owner</p>
                <span>We'll notify you at {{ bookingData.email || user?.username }}</span>
            </div>
            </div>
            </div>
        }
    </div>
</div>